import React, { useEffect } from "react";
import { connect } from "react-redux";
import { SketchPicker, Color } from "react-color";
import { Button, Row, Col } from "reactstrap";
import { colorHelper } from "../../helpers/colorHelper";
import Popover from "@material-ui/core/Popover";
import { cmsActions } from "../../store/actions/cms/cms.action";
import TemplateColors from "./TemplateColors";
import { makeStyles, createStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) =>
  createStyles({
    popover: {
      pointerEvents: "none",
    },
    paper: {
      backgroundColor: "transparent",
    },
  })
);
//
const ColorPickerFacade = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    props.dispatch(cmsActions.blockDeselect(true));
    //load all colors from template
  };
  const handleClose = () => {
    setAnchorEl(null);
    setTimeout(() => props.dispatch(cmsActions.blockDeselect(false)), 2000);
  };
  const classes = useStyles();
  const { color, onChange, path, dark = false } = props;
  const open = Boolean(anchorEl);
  const id = open ? `${path.replace(".", "-")}` : undefined;
  return (
    <React.Fragment>
      <Row style={{ margin: "0px" }}>
     
        <Col style={{ textAlign: "right", padding: "0px" }}>
          <Button
            onClick={handleClick}
            className={
              color == "unset" || color == undefined ? "unset-color" : ""
            }
            style={{
              backgroundColor: color,
              border: "2px solid rgb(224, 224, 224)",
              borderRadius: "0.25rem",
              width: "40px",
              color: color && colorHelper.getCorrectTextColor(color),
              textOverflow: "ellipsis",
              overflow: "hidden",
              maxWidth: "126px",
              fontFamily: "unset",
              minHeight: "30px",
            }}
          ></Button>
          <React.Fragment>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              classes={{
                paper: classes.paper,
              }}
              onClose={handleClose}
              style={{ zIndex: 10000 }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <SketchPicker
                color={color}
                className={dark ? "dark-l3 primary-text c-picker" : ""}
                disableAlpha={false}
                onChangeComplete={(color, e) => onChange(color, e, path)}
              />

            <TemplateColors
                className={dark ? "dark-l3 primary-text" : ""}
                path={path} 
                onClick={onChange}
              />
            </Popover>
          </React.Fragment>
        </Col>
      </Row>
    </React.Fragment>
  );
};
function mapStateToProps(state) {
  return {
    usedColors: state.template.usedColors,
  };
}
export default connect(mapStateToProps)(ColorPickerFacade);
